import {ReportModalComponent} from '../../components/report-modal/report-modal.component';
import {firstValueFrom, Subject} from 'rxjs';
import moment from 'moment';
import {BasePage} from './../base.page';
import {UserModel} from 'src/app/models/user.model';
import {finalize, take, takeUntil} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from 'src/app/services/auth.service';
import {ChatService} from 'src/app/services/chat.service';
import {UserService} from 'src/app/services/user.service';
import {PusherService} from 'src/app/services/pusher.service';
import {PaginatedResponse} from 'src/app/models/paginated-response.model';
import {ErrorHandlerService} from 'src/app/services/error-handler.service';
import {OfferDetailModel, ProductModel} from './../../models/wardrobe.model';
import {
  ChangeDetectorRef,
  Component,
  NgModule,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ChatModel,
  ChatPayloadModel,
  ConversationModel,
} from 'src/app/models/chat.model';
import {SwapItemModalComponent} from 'src/app/components/swap-item-modal/swap-item-modal.component';
import {PriceDiscountModalComponent} from './../../components/price-discount-modal/price-discount-modal.component';
import {
  IonContent,
  IonInfiniteScroll,
  LoadingController,
  ModalController,
  Platform,
  ToastController,
  ActionSheetController,
} from '@ionic/angular';
import {SubscribeNowModalComponent} from 'src/app/components/subscribe-now-modal/subscribe-now-modal.component';
import {
  CancelSwapRequestComponent
} from 'src/app/components/cancel-swap-request-modal/cancel-swap-request-modal.component';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
// import { LinkifyPipe } from 'src/app/pipes/linkify/linkify.pipe';
import {LinkifyModule} from 'src/app/pipes/linkify/linkify.module';
import {STATUS_ACCEPTED, STATUS_CANCELED} from 'src/app/constants/general.constant';
import {DeliveryPickupModalComponent} from 'src/app/components/delivery-pickup-modal/delivery-pickup-modal.component';
import {ShippingService} from 'src/app/services/shipping.service';
import {OfferService} from 'src/app/services/offer.service';
import {
  BuyerShippingAddressPaymentComponent
} from 'src/app/components/buyer-shipping-address-payment/buyer-shipping-address-payment.component';
import {
  SellerShippingAddressComponent
} from 'src/app/components/seller-shipping-address/seller-shipping-address.component';
// import { PaymentResultPage } from '../payment-result/payment-result.page';
import {
  PayShippingWithMollieComponent
} from 'src/app/components/pay-shipping-with-mollie/pay-shipping-with-mollie.component';
import {OfferItemComponent} from 'src/app/components/offer-item/offer-item.component';
import {File} from '@awesome-cordova-plugins/file/ngx';
import {AndroidPermissions} from '@awesome-cordova-plugins/android-permissions/ngx';
import {AlertController} from '@ionic/angular';

@Component({
  selector: 'shc-chat-detail',
  templateUrl: './chat-detail.page.html',
  styleUrls: ['./chat-detail.page.scss'],
})
export class ChatDetailPage extends BasePage implements OnInit {
  message = '';
  userId: number;
  chatId: string;
  status: boolean;
  form: UntypedFormGroup;
  // orderForm : UntypedFormGroup;
  chatDetail: ChatModel;
  product: ProductModel;
  offer: OfferDetailModel;
  trackingNumber: string | null = null;
  trackingLink: string | null = null;
  payload: ChatPayloadModel;
  selectedPhotos: Array<string>;
  messagesList: Array<ConversationModel>;
  messagesSource: PaginatedResponse<ConversationModel>;
  protected readonly destroySubscription = new Subject<boolean>();
  @ViewChild(IonContent, {static: false, read: IonContent})
  myContent: IonContent;
  @ViewChild(IonInfiniteScroll, {static: false})
  infiniteScroll: IonInfiniteScroll;
  private onChatKeyboardShow = (ev: any) => {
    const keyboardHeight = ev?.detail?.keyboardHeight || ev?.keyboardHeight || 0;
    document.documentElement.style.setProperty('--chat-keyboard-height', keyboardHeight + 'px');
    this.scrollToBottom();
  };

  private onChatKeyboardHide = () => {
    document.documentElement.style.setProperty('--chat-keyboard-height', '0px');
  };

  // UI Flags
  showPickupConfirmation = false;
  showPickupFollowUpButton = false;
  showDeliveryFormButton = false;
  showFallbackButton = false;
  formSubmittedSuccessfully = false;
  paymentAuthorizedFlag = false;
  canCancelSwop = true;
  showShippingAddressForm = false;
  showLabelReadyModal = false;
  saveAddress = 0;
  isModalOpen = false;
  showSellerAddressbtn = false;
  showDownloadBtn = false;
  messageSeller = '';
  messageSellerflag = false;
  paymentSellerflag = false;
  isShowShippingLabel = true;
  // Offer management
  offerButtonStates: { [offerId: number]: any } = {};
  offers: any[] = [];
  paymentMsg: boolean;
  toastCtrl: any;
  pickedMsg: boolean;
  address_found_Offer: any;
  showPaymentRefundedText = false;
  shouldHideShipPickUpModal = false;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private chatService: ChatService,
    private pusherService: PusherService,
    private modalCtrl: ModalController,
    private router: Router,
    private actionSheetController: ActionSheetController,
    public linkify: LinkifyModule,
    private sendCloudService: ShippingService,
    private offerService: OfferService,
    private file: File,
    private androidPermission: AndroidPermissions,
    private alertCtrl: AlertController, // 👈 add this line
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
    );
    this.route.params.subscribe((res) => {
      this.initChat();
      console.log(this.user, 'user');
    });
  }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      offer_id: new UntypedFormControl(null),
      message: new UntypedFormControl(null),
      orderType: new UntypedFormControl(null), // add this line
    });
    this.user$.pipe(take(1)).subscribe((user: UserModel) => {
      this.user = user;
      console.log('🚀 ~ this.user$.pipe ~ this.user:', this.user);
      // console.log("🚀 ~ this.user$.pipe ~ this.user:", this.form.offer_id);
    });
    // this.orderForm = new UntypedFormGroup({
    //   orderType: new UntypedFormControl(null)
    // });

  }

  ionViewWillEnter() {
    window.addEventListener('keyboardDidShow', this.onChatKeyboardShow);
    window.addEventListener('keyboardDidHide', this.onChatKeyboardHide);
  }

  ionViewWillLeave() {
    window.removeEventListener('keyboardDidShow', this.onChatKeyboardShow);
    window.removeEventListener('keyboardDidHide', this.onChatKeyboardHide);
    document.documentElement.style.setProperty('--chat-keyboard-height', '0px');
    this.destroySubscription.next(true);
    if (this.chatDetail && this.chatDetail.id) {
      this.pusherService.unBindChatEvent(this.chatDetail.id);
    }
    this.chatService.refreshUnreadChatsCount();
  }

  initChat() {
    this.messagesList = [];
    if (this.infiniteScroll) {
      this.infiniteScroll.disabled = true;
    }
    // this.chatId = this.route.snapshot.paramMap.get('id');
    this.chatId = this.route.snapshot.paramMap.get('id') || this.route.snapshot.paramMap.get('chatId');

    this.user$.subscribe((user: UserModel) => {
      this.userId = user.id;
      this.pusherService.initChat(this.chatId);
    });

    this.pusherService
      .getMessages()
      .pipe(takeUntil(this.destroySubscription))
      .subscribe((response) => {
        if (response.message_id) {
          this.chatId = this.route.snapshot.paramMap.get('id');
          this.messagesRead(response.message_id);
          console.log('response', response);
        }
      });

    if (this.chatId) {
      // Bij een 429 (rate-limit, throttle:api 60/min) 1x stil opnieuw proberen na
      // 2.5s in plaats van de pagina met lege chatDetail/product te laten hangen
      // (gaf voorheen "Dit item is verwijderd"/Invalid date tot handmatige refresh).
      // Pas bij een herhaalde 429 alsnog de bestaande toast tonen (UX: transiente
      // fouten die zichzelf oplossen hoeven niet getoond te worden).
      const loadChatDetail = (isRetry = false) => {
        this.chatService.getChatDetail(this.chatId).subscribe(
          (chatRequest: ChatModel) => {
            this.chatDetail = chatRequest;
            this.product = chatRequest?.chatable;
            console.log('chatDetail', this.chatDetail, 'product Detail', this.product);
            this.checkAndShowPickupModal();
          },
          (error) => {
            if (error?.status === 429 && !isRetry) {
              setTimeout(() => loadChatDetail(true), 2500);
              return;
            }
            this.errorService.handle(error);
          },
        );
      };
      loadChatDetail();
      this.showLoader();
      this.chatService
        .getConversation(this.chatId, {per_page: 50})
        .pipe(finalize(() => this.hideLoader()))
        .subscribe(
          (list) => {
            this.messagesSource = list;
            this.messagesList = [...list.data.reverse()];
            this.cd.detectChanges();

            console.log('chat detail', this.chatDetail);

            setTimeout(() => {
              this.scrollToBottom();
            }, 1000);
          },
          (error) => {
            this.errorService.handle(error);
          },
        );
    }
  }

  private resetShippingUIFlags() {
    this.showPickupConfirmation = false;
    this.showPickupFollowUpButton = false;
    this.showDeliveryFormButton = false;
    this.showFallbackButton = false;
    this.showShippingAddressForm = false;
    this.showLabelReadyModal = false;

  }

  openTrackingLink() {
    if (this.trackingLink) {
      if ((window as any).cordova && (window as any).cordova.InAppBrowser) {
        (window as any).cordova.InAppBrowser.open(this.trackingLink, '_system');
      } else {
        window.open(this.trackingLink, '_system');
      }
    }
  }

  onPickupChoiceMade(pickupChoice: any) {
    if (pickupChoice?.delivery_method === 'delivery') {
      this.openDeliveryModal();
    } else if (pickupChoice?.delivery_method === 'pickup') {
      this.confirmPicked('Pickup');
    }
  }

  async showPickupModal() {
    this.resetShippingUIFlags();
    this.isModalOpen = true;
    this.showPickupFollowUpButton = false; // Hide button when modal is shown

    const modal = await this.modalCtrl.create({
      component: DeliveryPickupModalComponent,
      canDismiss: true,
      backdropDismiss: true,
      componentProps: {
        userId: this.userId,
        product: this.product,
        productId: this.product?.id,
        chatId: this.chatId,
        userType: this.userId !== this.product?.user?.id ? 'buying' : 'selling',
        isModalOpen: this.isModalOpen
      },
    });
    modal.onDidDismiss().then(({data}) => {
      console.log('Modal dismissed with data:', data, data?.selectedOrderType);

      if (data?.selectedOrderType === 'pickup') {
        this.isModalOpen = false;
        this.showPickupConfirmation = true;
        this.showPickupFollowUpButton = false;
      } else if (data?.selectedOrderType === 'delivery') {
        this.openDeliveryModal();
        this.showPickupFollowUpButton = false;
      } else {
        this.showPickupFollowUpButton = true;
        this.isModalOpen = false;
      }
    });

    await modal.present();

    await modal.onWillDismiss();

  }


  async openDeliveryModal() {
    this.isModalOpen = true;
    this.showPickupFollowUpButton = false;
    const modal = await this.modalCtrl.create({
      component: BuyerShippingAddressPaymentComponent,
      canDismiss: true,
      backdropDismiss: true,
      componentProps: {
        userId: this.userId,
        product: this.product,
        productId: this.product?.id,
        chatId: this.chatId,
        userType: this.userId !== this.product?.user?.id ? 'buying' : 'selling',
        formSubmittedSuccessfully: false,
      },
    });
    modal.onDidDismiss().then((result) => {
      if (data?.selectedOrderType !== 'delivery') {
        // debugger

        this.isModalOpen = false;
      }
    });
    await modal.present();

    const {data, role} = await modal.onWillDismiss();

    if (role === 'cancel' || role === 'backdrop' || !data || Object.keys(data).length === 0) {
      this.isModalOpen = false;
      // debugger
      this.showPickupFollowUpButton = true;
      return;
    }

    if (data?.paymentSuccess) {
      this.showPickupFollowUpButton = false;
    } else {
      this.showPickupFollowUpButton = true;
    }
  }

  async openPaymentModal() {
    this.isModalOpen = true;
    this.showPickupFollowUpButton = false;

    const modal = await this.modalCtrl.create({
      component: PayShippingWithMollieComponent,
      canDismiss: true,
      backdropDismiss: true,
      componentProps: {
        userId: this.userId,
        product: this.product,
        productId: this.product?.id,
        chatId: this.chatId,
        userType: this.userId !== this.product?.user?.id ? 'buying' : 'selling',
        formSubmittedSuccessfully: this.formSubmittedSuccessfully,
      },
    });
    modal.onDidDismiss().then((result) => {
      // if(data?.selectedOrderType !== 'delivery'){
      if (data?.selectedOrderType === 'delivery') {
        // debugger
        this.isModalOpen = false; // Modal closed
        this.paymentAuthorizedFlag = true;
        this.formSubmittedSuccessfully = true;
      }
    });
    await modal.present();

    const {data, role} = await modal.onWillDismiss();

    if (role === 'cancel' || role === 'backdrop' || !data || role === 'click' || !data || Object.keys(data).length === 0) {
      this.isModalOpen = false;
      // debugger
      this.showPickupFollowUpButton = true;
      this.formSubmittedSuccessfully = true;
      return;
    }
    // debugger
    console.log(data);
    if (data?.paymentSuccess) {
      this.showPickupFollowUpButton = false;
    } else {
      this.isModalOpen = false;
      this.showPickupFollowUpButton = true;
    }
  }

// Step 2: Buyer fills shipping address + payment
  async showShippingAddressFormModal() {
    this.resetShippingUIFlags();
    if (!this.chatId || !this.userId) {
      console.error('chatId or userId is missing!');
      this.showErrorMessage('Missing necessary user or chat information.');
      return;
    }

    const modal = await this.modalCtrl.create({
      component: BuyerShippingAddressPaymentComponent,
      canDismiss: true,
      backdropDismiss: false,
      componentProps: {
        chatId: this.chatId,
        userId: this.userId,
      },
    });

    await modal.present();

    const {data, role} = await modal.onWillDismiss();

    if (role === 'submit' && data?.address && data?.paymentSuccessful) {
      // The modal already sent the order, so just show thank you
      this.showThankYouMessage();
    } else if (role === 'submit') {
      this.showErrorMessage('Please complete all required fields and ensure payment is successful.');
      await this.showShippingAddressFormModal(); // Reopen modal for retry
    } else {
      this.showErrorMessage('You have not entered any shipping information yet.');
      this.showDeliveryFormButton = true;
    }
  }

// Main flow checker
  checkAndShowPickupModal(): void {
    this.user$.subscribe((user: UserModel) => {
      this.userId = user.id;
      const userId = this.userId;
      const offered_product_id = this.product?.offers_count;
      console.log('offered_product_id', offered_product_id);
      const product_Id = this.product?.id;
      const product_userId = this.product?.user?.id;
      const userType = userId !== product_userId ? 'buying' : 'selling';
      this.isShowShippingLabel = userType === 'selling';

      console.log(this.isShowShippingLabel);

      this.sendCloudService.getShippingData(userType, userId, product_Id, null).subscribe({
        next: (response) => {
          const shippingType = response?.shipping_type ?? '';
          const shippingDetails = response?.shipping_details;
          this.trackingNumber = shippingDetails?.tracking_number ?? null;
          this.trackingLink = shippingDetails?.tracking_link ?? null;
          const orderStatus = response?.order_status ?? 0;
          const address_found = response?.address_found ?? 0;
          // 18 aug: seller_address_found verwijderd -- Sendcloud-restant (twee adressen
          // nodig), sinds MyParcel (11 aug) structureel altijd 0, blokkeerde downloadkaart.
          const hasNoShippingDetails = !shippingDetails || Object.keys(shippingDetails).length === 0;
          const buyerShipping = response?.buyer_shipping ?? 0;
          const message_seller = response?.message ?? '';
          const paymentAuthorized = response?.payment_authorized ?? 0;
          const isPaymentRefunded = response?.payment_details?.mollie_payment_status === 'refunded';
          this.canCancelSwop = paymentAuthorized === 0 && !shippingDetails?.parcel_label;
          // const isPaymentObjectFound = response?.payment_details?.id;

          console.log('isPaymentRefunded = ', isPaymentRefunded);

          // This will check if there's no offer mean the swop already removed or cancelled. Or, one of the status is "Closed", We are not showing pickup modal.
          const hasClosedOffer = this.chatDetail?.offers?.length === 0 ||
            this.chatDetail?.offers?.some(offer => offer.status === 'CLOSED');

          console.log('hasClosedOffer = ', hasClosedOffer);

          if (hasClosedOffer === true || isPaymentRefunded === true) {
            console.log('There is at least one CLOSED offer');
            this.shouldHideShipPickUpModal = true;
          }

          if (isPaymentRefunded) {
            this.showPaymentRefundedText = true;
          }
          console.log('Shipping Type:', shippingType, 'UserType:', userType, 'address_found', address_found);
          console.log('Shipping Details:', response);

          // Buyer flow
          if (userType === 'buying') {
            console.log('openPaymentModal', shippingType, paymentAuthorized, address_found, isPaymentRefunded);
            if (shippingType === '' && hasNoShippingDetails) {
              // Oude losse modal vervangen door de in-chat pickup-choice (zie createChat()-hook backend-kant).
              if (orderStatus === 0) {
                this.showPickupFollowUpButton = false;
              }
            } else if (shippingType === 'Delivery' && paymentAuthorized === 0 && address_found === 1 && !isPaymentRefunded) {
              // Was: this.openPaymentModal() (oude, losse PayShippingWithMollieComponent).
              // Nu: openDeliveryModal() -> BuyerShippingAddressPaymentComponent, dat het
              // bestaande adres vooraf invult en direct het betaalgedeelte toont bij een retry.
              this.showPickupFollowUpButton = false;
              this.paymentAuthorizedFlag = true;
              this.openDeliveryModal();
            } else if (address_found === 1 && paymentAuthorized === 1) {
              this.paymentMsg = true;
            } else if (shippingType === 'Pickup') {
              console.log('orderStatus, shippingType', orderStatus, shippingType);
              if (hasNoShippingDetails && orderStatus === 0) {
                this.showPickupConfirmation = true;
              }
              if (orderStatus === 1) {
                this.showPickupConfirmation = false;
                this.showShippingAddressForm = false;
                this.pickedMsg = true;
              }
            }
          }

          // Seller flow
          // MyParcel vereist geen apart verkoperadres (zit in het MyParcel-account),
          // dus 'address_found' (verkoper's eigen adres) is niet meer relevant hier.
          // Zodra de koper betaald heeft, is het label direct klaar om te downloaden --
          // geen tussenstap voor een eigen adres meer (was Sendcloud-restant).
          else if (userType === 'selling') {
            if (buyerShipping === 1 && paymentAuthorized === 0) {
              this.paymentSellerflag = true;
            } else if (buyerShipping === 1 && paymentAuthorized === 1 && !!shippingDetails?.parcel_label) {
              this.messageSellerflag = true;
            }
          }

          if (shippingType === 'Delivery' && paymentAuthorized === 1 && !!shippingDetails?.parcel_label) {
            this.showDownloadBtn = true;
          }
          if (address_found === 0) {
            this.address_found_Offer = true;
          } else {
            this.address_found_Offer = false;
          }
        },
        error: (err) => {
          console.error('API error fetching shipping data:', err);
        }
      });

    });
  }

  showThankYouMessage() {
    // Replace this with your actual UI feedback mechanism
    console.log('Thank you! Waiting for sender\'s address.');
  }

  async showSellerShippingAddressModal(prefillData?: any) {
    this.resetShippingUIFlags();
    const modal = await this.modalCtrl.create({
      component: SellerShippingAddressComponent,
      canDismiss: true,
      backdropDismiss: false,
      componentProps: {
        userId: this.userId,
        product: this.product,
        productId: this.product?.id,
        chatId: this.chatId,
        userType: this.userId !== this.product?.user?.id ? 'buying' : 'selling',
        prefillData: prefillData || null,
        isModalOpen: this.isModalOpen,
      },
    });
    modal.onDidDismiss().then((result) => {
      this.isModalOpen = false;
      this.showSellerAddressbtn = false; // Hide button when modal is closed

      const allFieldsFilled = Object.values(result).every(
        (value) => value !== null && value !== ''
      );

      if (allFieldsFilled) {
        this.messageSellerflag = true;
      } else {
        this.showSellerAddressbtn = true;
      }

    });

    await modal.present();

    const {data, role} = await modal.onWillDismiss();

  }

  async downloadShippingLabel() {
    this.sendCloudService.getSignedLabelUrl(this.product.id, this.userId).subscribe({
      next: async (res) => {
        if (res.status === 'success' && res.url) {
          (window as any).cordova.InAppBrowser.open(res.url, '_system');
        } else {
          await this.showPopup(res.message || 'Failed to load label');
        }
      },
      error: async (err) => {
        console.error('Download error:', err);
        await this.showPopup(err);
      }
    });
  }

  private async showPopup(message: string) {
    const translatedHeader = this.translate.instant('Toast.labelDownloaded');
    const translatedSend = this.translate.instant('Toast.labelSend');

    const alert = await this.alertCtrl.create({
      cssClass: 'custom-alert-style',
      header: translatedHeader,
      message: `
    <strong>${translatedSend}</strong>
    <br><br>${message}
    `,
      buttons: [
        {
          text: 'ok', // 👈 translated text
          role: 'confirm',
          cssClass: 'popup-ok-btn'
        }
      ],
    });

    await alert.present();
  }


  private async ensureDir(path: string, dirName: string) {
    try {
      await this.file.checkDir(path, dirName);
      console.log(`Directory exists: ${dirName}`);
    } catch {
      console.log(`Creating directory: ${dirName}`);
      await this.file.createDir(path, dirName, false);
    }
  }

  showErrorMessage(message: string): void {
    alert(message);
  }

  async confirmPicked(selectedType: string, offer?: any): Promise<void> {
    let order_status = 1;
    try {
      const user: UserModel = await firstValueFrom(this.user$);
      this.userId = user.id;

      const userId = this.userId;
      const product_Id = this.product?.id;
      const product_userId = this.product?.user.id;
      const userType = userId !== product_userId ? 'buying' : 'selling';
      await this.sendCloudService.confirmOrder(
        userId,
        product_Id,
        order_status
      ).toPromise();
      this.pickedMsg = true;
      await this.modalCtrl.dismiss(
        {orderType: selectedType, confirmed: true},
        'submit'
      );
    } catch (error) {
      console.error('Error submitting shipping details:', error);
      this.showPickupConfirmation = true;
    } finally {
      this.showPickupConfirmation = false;
      this.showPickupFollowUpButton = false;
    }
  }

  ionViewDidEnter() {
    this.scrollToBottom();
  }

  sendCounterOffer(data) {
    if (data && data.data) {
      // debugger
      console.log('counter offer', data)
      this.offer = data.data;
      this.sendMessage();
    }
  }

  /**
   * called on message dispatch
   * @param message string
   */
  sendMessage() {
    if (!this.form.value.message && !this.offer) {
      return;
    }

    this.chatId = this.route.snapshot.paramMap.get('id');
    this.payload = {
      product_id: this.product?.id,
      message: this.form.value.message || 'offer',
      type: this.offer && this.offer?.id ? 'offer' : 'message',
      offer_id: this.offer?.id,
      match_id: this.chatId,
      created_at: new Date(),
      sent_at: moment(new Date()).fromNow(),
      sender: {
        id: this.user.id,
      },
    };
    this.reset();

    console.log(this.payload);
    this.chatService.sendMessage(this.payload).subscribe(
      (res: any) => {
        this.offer = null;
        this.chatId = res.chat_id;
        this.pushText(res);
        this.cd.detectChanges();
        setTimeout(() => {
          this.scrollToBottom();
        }, 200);
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  /**
   * Responsible for showing messages in view
   */
  pushText(payload: any) {
    if (payload?.id && this.messagesList.some((m) => m.id === payload.id)) {
      return;
    }
    this.messagesList = [...this.messagesList, payload];
  }

  /**
   * reset the form
   */
  reset() {
    this.form.reset();
  }

  /**
   * Get message data by messageId
   */
  messagesRead(messageId: string) {
    this.chatService.messagesRead(messageId).subscribe(
      (response) => {
        console.log(response);
        this.pushText(response);
        setTimeout(() => {
          this.scrollToBottom();
        }, 500);
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  /**
   * will scroll the element to bottom
   */
  async scrollToBottom() {
    await this.myContent.scrollToBottom(500);
    if (this.infiniteScroll) {
      this.infiniteScroll.disabled = false;
    }
  }

  async swapItem() {
    const modal = await this.modalCtrl.create({
      component: SwapItemModalComponent,
      componentProps: {
        senderId: this.chatDetail?.users[0]?.id,
        actualProductId: this.product?.id,
      },
      cssClass: 'my-custom-class',
      canDismiss: true,
      id: 'swapItem',
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the SwipeItemModalComponent modal is closed
      if (data && data.data) {
        console.log('swapItem data.data', data.data)
        this.offer = data.data;
        this.sendMessage();
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async cancelRequest() {
    console.log();

    const modal = await this.modalCtrl.create({
      component: CancelSwapRequestComponent,
      componentProps: {
        chatId: this.chatId,
        isRequester: this.userId !== this.product?.user?.id,
        // senderId: this.chatDetail?.users[0]?.id,
        // actualProductId: this.product?.id
      },
      cssClass: 'my-custom-class',
      canDismiss: true,
      id: 'cancelSwapRequest',
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the SwipeItemModalComponent modal is closed
      if (data && data.data) {
        this.offer = data.data;
        this.sendMessage();
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async priceDiscount() {
    const modal = await this.modalCtrl.create({
      component: PriceDiscountModalComponent,
      componentProps: {
        product: this.product,
        senderId: this.chatDetail?.users[0]?.id,
      },
      cssClass: 'my-custom-class',
      canDismiss: true,
      id: 'priceDiscount',
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the PriceDiscountModalComponent modal is closed
      if (data && data.data) {
        this.offer = data.data;
        console.log(this.offer);
        this.sendMessage();
      }
      this.modalCtrl.dismiss();
    });

    return await modal.present();
  }

  async presentActionSheet() {
    console.log(this.product);

    const buttonsArray = [
      {
        text: this.translate.instant(marker('Chat.DeleteConversion')),
        cssClass: '',
        icon: '../../../assets/icons/Path 6515.svg',
        handler: () => {
          this.chatService.delete(this.chatId).subscribe(
            (res) => {
              this.errorService.showToast(
                this.translate.instant(marker('Chat.Delete.Success')),
              );
              this.router.navigate(['tabs', 'chat']);
            },
            (error) => {
              this.errorService.handle(error);
            },
          );
        },
      },
    ];

    if (this.product?.user?.id !== this.user?.id) {
      buttonsArray.push({
        text: this.chatDetail?.users[0]?.is_following
          ? this.translate.instant(marker('Chat.UnFollowUser'))
          : this.translate.instant(marker('Chat.FollowUser')),
        cssClass: '',
        icon: '../../../assets/icons/Group 6142.svg',
        handler: () => {
          // if (!this.user?.is_premium) {
          console.log('🚀 ~ presentActionSheet ~ this.user:', this.user)
          //   this.subscribeNow();
          //   return;
          // }
          this.userService
            .toggleFollowUser(this.chatDetail.users[0]?.id || this.product?.id)
            .subscribe((res) => {
              this.chatDetail.users[0].is_following =
                !this.chatDetail?.users[0]?.is_following;
            });
        },
      });
    }

    if (
      this.chatDetail?.users?.length &&
      !this.chatDetail?.users[0]?.is_reported &&
      this.chatDetail.status != 'canceled' &&
      this.canCancelSwop
    ) {
      buttonsArray.push({
        text: this.translate.instant(marker('Chat.CancelRequest')),
        cssClass: '',
        icon: '../../../assets/icons/times.svg',
        handler: () => {
          this.cancelRequest();
        },
      });
    }

    if (
      this.chatDetail?.users?.length &&
      !this.chatDetail?.users[0]?.is_reported
    ) {
      buttonsArray.push({
        text: this.translate.instant(marker('Chat.Report')),
        cssClass: '',
        icon: '../../../assets/icons/Group 6143.svg',
        handler: () => {
          this.presentReportReasons();
        },
      });
    }

    this.chatId = this.route.snapshot.paramMap.get('id');
    const actionSheet = await this.actionSheetController.create({
      mode: 'md',
      cssClass: 'chat-menu-action-sheet',
      buttons: buttonsArray,
    });
    await actionSheet.present();
  }

  async presentReportReasons() {
    const actionSheet = await this.actionSheetController.create({
      header: this.translate.instant(marker('Report.Title')),
      mode: 'md',
      cssClass: 'report-action-sheet',
      buttons: [
        {
          text: this.translate.instant(marker('Report.Reason.Spam')),
          cssClass: '',
          icon: 'megaphone-outline',
          handler: () => {
            this.reportUser(
              this.chatDetail?.users[0]?.id,
              this.translate.instant(marker('Report.Reason.Spam')),
            );
          },
        },
        {
          text: this.translate.instant(marker('Report.Reason.Inappropriate')),
          cssClass: '',
          icon: 'alert-circle-outline',
          handler: () => {
            this.reportUser(
              this.chatDetail?.users[0]?.id,
              this.translate.instant(marker('Report.Reason.Inappropriate')),
            );
          },
        },
        {
          text: this.translate.instant(marker('Report.Reason.Nuisance')),
          cssClass: '',
          icon: 'sad-outline',
          handler: () => {
            this.reportUser(
              this.chatDetail?.users[0]?.id,
              this.translate.instant(marker('Report.Reason.Nuisance')),
            );
          },
        },
        {
          text: this.translate.instant(marker('Report.Reason.ScamOrFraud')),
          cssClass: '',
          icon: 'shield-outline',
          handler: () => {
            this.reportUser(
              this.chatDetail?.users[0]?.id,
              this.translate.instant(marker('Report.Reason.ScamOrFraud')),
            );
          },
        },
        {
          text: this.translate.instant(marker('Report.Reason.SomethingElse')),
          cssClass: '',
          icon: 'ellipsis-horizontal-outline',
          handler: () => {
            this.showOtherModal();
          },
        },
      ],
    });
    await actionSheet.present();
  }

  async showOtherModal() {
    const modal = await this.modalCtrl.create({
      component: ReportModalComponent,
      cssClass: 'product-category-modal-create',
      id: 'productCategory',
    });

    modal.onDidDismiss().then((data) => {
      console.log(data);

      if (data && data.data) {
        this.reportUser(this.chatDetail?.users[0]?.id, data.data);
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  reportUser(userId: number, message: string) {
    this.showLoader();

    this.userService.reportUser({message}, userId).subscribe(
      (res: any) => {
        this.translate.get(marker('Report.Reported')).subscribe((msg) => {
          this.showToast(msg);
          this.hideLoader();
          // this.form.reset();
          this.router.navigate(['/tabs/home']);
        });
      },
      (error) => {
        this.hideLoader();
        this.errorService.handle(error);
      },
    );
    console.log('🚀 ~ reportUser ~ this.user:', this.user)
  }

  routeToUserDetail(id: number) {
    if (id === null) {
      return;
    }

    this.router.navigate(['user', id]);
  }

  async subscribeNow() {
    const modal = await this.modalCtrl.create({
      component: SubscribeNowModalComponent,
      cssClass: 'subscribeNow',
      id: 'subscribeNow',
      keyboardClose: true,
      mode: 'md',
      backdropDismiss: true,
      canDismiss: true,
    });
    modal.onDidDismiss().then((data) => {
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  getTimeFromNow(date) {
    return moment(date).fromNow();
  }

  getTimeFromDate(date: string) {
    // 24-uurs formaat, consistent met chat.page.ts en base.page.ts (29 aug 2026) --
    // was 'hh:mm A' (12-uurs met AM/PM), enige afwijkende plek in de app.
    return moment(date).locale(this.user?.locale || 'en').format('HH:mm');
  }

  getMonthAndDate(date: string) {
    return moment(date).locale(this.user?.locale || 'en').format('DD MMM YYYY').toUpperCase();
  }

  assignOfferClass(msg, userId) {
    if (msg.is_system) {
      return 'systemMsg';
    } else if (msg.type === 'offer' && msg.offer.sent_by.id === userId) {
      return 'selfMsg selfOffer';
    } else if (msg.type === 'offer' && msg.offer.sent_by.id !== userId) {
      return 'offer';
    } else if (msg.type === 'message' && msg.sender.id === userId) {
      return 'selfMsg';
    } else {
      return '';
    }
  }

  chatUserImage(msg, userId) {
    if (msg.type === 'offer') {
      // if (msg.offer.sent_by.id === userId) {
      //   return msg?.offer?.sent_by?.avatar?.url ? msg?.offer?.sent_by?.avatar?.url : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';
      // } else {
      return msg?.offer?.sent_by?.avatar?.url
        ? msg?.offer?.sent_by?.avatar?.url
        : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';
      // }
    } else if (msg.type === 'message') {
      if (msg.sender.id === userId) {
        return this.user?.avatar?.url
          ? this.user?.avatar?.url
          : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';
      } else {
        return msg?.sender?.avatar?.url
          ? msg?.sender?.avatar?.url
          : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';
      }
    } else {
      return 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';
    }
  }
}
